import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { useManualFormValues } from '@asteria/component-form';

import * as AppStore from '@asteria/datalayer/stores/app';

import { getPath } from '../../../utils/getFormPaths';
import { useTransactions } from '../../../utils/operations';

export function useOverallValue({
	type,
	/* dates, */
	category,
	tag,
	includeFuture,
	includeHistory,
}) {
	const { getValues } = useFormContext();

	const dates = Array.from(
		new Set([].concat(Object.keys(getValues()?.[type]?.data ?? {}))),
	);

	const tagId = useSelector((store) => {
		if (tag === '$deposit' || tag === '$withdraw') {
			return null;
		}

		const tags = AppStore.selectors.tags(store);
		const storedTag = tags.find((item) => item?.name === tag);

		return storedTag?._id ?? storedTag?.id;
	});

	const future = useTransactions({
		types: [type],
		tagId: tagId,
		startDate: dates?.[0],
		endDate: dates?.[dates.length - 1],
	}).map(({ payload }) => payload.total);

	const historical = useManualFormValues({
		name: dates.map((date) =>
			getPath({
				type: type,
				date: date,
				status: 'PAID',
				category: category,
				tag: tag,
				field: 'value',
			}),
		),
	});

	if (dates.length === 0) {
		return 0;
	}

	return []
		.concat(includeFuture ? future : [])
		.concat(includeHistory ? historical : [])
		.reduce((acc, value) => acc + (value || 0), 0);
}
